// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/settings/production/${file}.vue`);

export default [
  //
  // bill type
  //
  {
    path: "/bill-type",
    name: "bill-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("bill-type"),
    },
  },
  {
    path: "/bill-type/review/:id",
    name: "bill-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("bill-type"),
    },
  },
  {
    path: "/bill-type/edit/:id",
    name: "bill-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("bill-type"),
    },
  },
  {
    path: "/bill-type/create",
    name: "bill-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("bill-type"),
    },
  },
  //
  // labour groups
  //
  {
    path: "/labour-groups",
    name: "labour-groups",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-groups"),
    },
  },
  {
    path: "/labour-groups/review/:id",
    name: "labour-groups-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-groups"),
    },
  },
  {
    path: "/labour-groups/edit/:id",
    name: "labour-groups-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-groups"),
    },
  },
  {
    path: "/labour-groups/create",
    name: "labour-groups-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-groups"),
    },
  },
  //
  // departments
  //
  {
    path: "/departments",
    name: "departments",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("departments"),
    },
  },
  {
    path: "/departments/review/:id",
    name: "departments-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("departments"),
    },
  },
  {
    path: "/departments/edit/:id",
    name: "departments-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("departments"),
    },
  },
  {
    path: "/departments/create",
    name: "departments-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("departments"),
    },
  },
  //
  // labour resources
  //
  {
    path: "/labour-resources",
    name: "labour-resources",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-resources"),
    },
  },
  {
    path: "/labour-resources/review/:id",
    name: "labour-resources-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-resources"),
    },
  },
  {
    path: "/labour-resources/edit/:id",
    name: "labour-resources-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-resources"),
    },
  },
  {
    path: "/labour-resources/create",
    name: "labour-resources-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("labour-resources"),
    },
  },
  //
  // production processes
  //
  {
    path: "/production-processes",
    name: "production-processes",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("production-processes"),
    },
  },
  {
    path: "/production-processes/review/:id",
    name: "production-processes-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("production-processes"),
    },
  },
  {
    path: "/production-processes/edit/:id",
    name: "production-processes-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("production-processes"),
    },
  },
  {
    path: "/production-processes/create",
    name: "production-processes-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("production-processes"),
    },
  },

  // Exception Reasons
  {
    path: "/exception-reasons",
    name: "exception-reasons-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("exception-reasons"),
    },
  },
  {
    path: "/exception-reasons/create",
    name: "exception-reasons-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("exception-reasons"),
    },
  },
  {
    path: "/exception-reasons/review/:id",
    name: "exception-reasons-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("exception-reasons"),
    },
  },

  {
    path: "/exception-reasons/edit/:id",
    name: "exception-reasons-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSettings",
    },
    components: {
      content: lazyLoad("exception-reasons"),
    },
  },
];
